import { render, staticRenderFns } from "./TierPrice.vue?vue&type=template&id=24407b44&"
import script from "./TierPrice.vue?vue&type=script&lang=js&"
export * from "./TierPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports